import { useNavigate } from 'react-router-dom';
import { Box, Card, CardContent, Typography } from '@material-ui/core';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import CheckIcon from '@material-ui/icons/Check';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';

import { useSelector, shallowEqual, useDispatch } from 'react-redux';
import { getSubscriptionInfoAction } from '../../store/actions/subscription';

import { ColorButton, Tooltip } from '../common';
import { useAlert } from '../../hooks';

const useStyles = makeStyles((theme) =>
	createStyles({
		getButtom: {
			margin: '20px 0 10px 0',
		},
	}),
);

const ProductCard = ({ plan, ...rest }) => {
	const classes = useStyles();
	// const paddle = window.Paddle;
	const navigate = useNavigate();
	const callAlert = useAlert();
	const dispatch = useDispatch();
	const profile = useSelector((state) => state?.profile, shallowEqual);

	const handleSelectPlan = () => {
		if (plan && plan.link)
			document.location.href = `${plan.link}?client_reference_id=${profile?.uid}&prefilled_email=${encodeURIComponent(profile?.email)}`;
		else 
			callAlert(
			"No payment link assigned for the selected subscription plan",
			'error',
			{ autoHideDuration: 8000 },
			);

		// paddle.Checkout.open({
		// 	product: plan.id,
		// 	email: profile?.email,
		// 	passthrough: JSON.stringify({ uid: profile?.uid, affiliation: 'affiliation' }),
		// 	successCallback: (data, err) => {
		// 		const checkoutId = data.checkout.id;
		// 		paddle.Order.details(checkoutId, function successCallback(successData) {
		// 			navigate('/dashboard', { replace: true });
		// 			callAlert(
		// 				'You have successfully subscribed to the selected plan. Your plan will be updated soon.',
		// 				'success',
		// 				{ autoHideDuration: 8000 },
		// 			);
		// 			dispatch(getSubscriptionInfoAction());
		// 		});
		// 	},
		// 	closeCallback() {},
		// });
	};

	return (
		<Card
			sx={{
				display: 'flex',
				flexDirection: 'column',
				height: '100%',
			}}
			{...rest}
		>
			<CardContent>
				<Typography align="center" color="textPrimary" gutterBottom variant="h2">
					{plan?.title}
				</Typography>

				<Typography color="textPrimary" align="center" variant="body1" style={{fontWeight: 'bold', fontSize: '1.5em' }}>
					<span className="dollar">$</span>
					<span id="subscriber-numbers-target-basic" className="figure">
						{plan?.price}
					</span>
					<span className="currency" />/{plan?.period}
				</Typography>

				<Typography align="center" color="textPrimary" variant="body1">
					{plan?.description}
				</Typography>
				<Box
					sx={{
						display: 'flex',
						justifyContent: 'center',
						pb: 3,
					}}
				>
					<ColorButton
						className={classes.getButtom}
						variant="contained"
						color={plan?.buttonColor || 'primary'}
						size="large"
						onClick={handleSelectPlan}
					>
						Start now
					</ColorButton>
				</Box>
				<Box sx={{ pb: 3 }}>
					{plan?.options?.map((i) => {
						return (
							<Box
								key={`${i.title}_${i.description}`}
								sx={{
									display: 'flex',
									alignItems: 'center',
									pb: 3,
								}}
							>
								<CheckIcon color="primary" />
								<Typography
									color="textPrimary"
									align="left"
									variant="body1"
									style={{ marginLeft: '10px' }}
								>
									{i?.title}
								</Typography>
								{i.description && (
									<Tooltip title={i.description}>
										<InfoOutlinedIcon color="primary" style={{ marginLeft: '10px' }} />
									</Tooltip>
								)}
							</Box>
						);
					})}
				</Box>
			</CardContent>
			<Box sx={{ flexGrow: 1 }} />
		</Card>
	);
};

export default ProductCard;
